import { Certification, SITE } from '../data/site';
import { Icon } from './icons';

interface CertificationsGridProps {
  certs?: readonly Certification[];
}

/** Microsoft certification badges. Falls back to the award icon; drop official
 *  Credly PNGs at public/certs/<code>.png and swap the icon for an <img> later. */
function CertificationsGrid({ certs = SITE.certifications }: CertificationsGridProps) {
  return (
    <div className="cert-grid">
      {certs.map(cert => (
        <div className="cert-badge" key={cert.code}>
          <span className="cert-badge-icon">
            <Icon id="award" size={22} />
          </span>
          <div className="cert-badge-text">
            <span className="cert-badge-code">{cert.code}</span>
            <span className="cert-badge-name">Microsoft Certified: {cert.name}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CertificationsGrid;
